import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';
import { layers } from '@atlaskit/theme/constants';
import Spinner from '@atlaskit/spinner';
import styled from '@emotion/styled';
var overlayZindex = layers.modal() + 10;
export var Blanket = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: ", ";\n"])), overlayZindex);
Blanket.displayName = 'Blanket';
export var SpinnerWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
SpinnerWrapper.displayName = 'SpinnerWrapper';
var defaultProps = {
  blankedColor: 'none',
  invertSpinnerColor: false
};
export default (function (_ref) {
  var blankedColor = _ref.blankedColor,
    invertSpinnerColor = _ref.invertSpinnerColor;
  return /*#__PURE__*/React.createElement(Blanket, {
    style: {
      backgroundColor: blankedColor || defaultProps.blankedColor
    }
  }, /*#__PURE__*/React.createElement(SpinnerWrapper, null, /*#__PURE__*/React.createElement(Spinner, {
    size: "large",
    appearance: invertSpinnerColor || defaultProps.invertSpinnerColor ? 'invert' : 'inherit'
  })));
});